/* Component in the CharacterBG Component to display the
   Character info
 * Contains the SceneCharacterEdit component */
import React from "react"
import styles from "../../../styles/Scene.module.css"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import { axiosInstance, axiosReq } from "../../../api/axiosDefaults"
import { useState } from "react"
import { PostDropdown } from "../../../components/PostDropdown"
import SceneCharacterEdit from "./SceneCharacterEdit"
import { CLIENT_PROGRAM_HOSTNAME } from "../../../utils/config"
import useHostName from "../../../hooks/useHostName"
import { useCurrentUser } from "../../../contexts/CurrentUserContext"
import toast from "react-hot-toast"; 

const Character = ({
  id,
  cast_number,
  role,
  costume,
  character,
  setCharacters,
  handleMount,
}) => {
  const host = useHostName()
  const [showEditForm, setShowEditForm] = useState(false)
  const currentUser = useCurrentUser()

  const handleDelete = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.delete(`/scenecharacters/${id}/`)
        toast.success(`Scene Character Deleted`);
        handleMount()
      } else {
        await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/scenecharacters/${id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        toast.success(`Scene Character Deleted Successfully!`);
        handleMount()
      }
    } catch (err) {
      // console.log(err);
    }
  }

  return (
    <div className={`text-center mx-4 px-2` }>
      <Row >
        <Col className={`${styles.TitleBox4}  text-center px-0 mx-0`} xs={2} >
        <p className="pt-2 pt-md-0" >{cast_number} </p>
        </Col>
        <Col className={`${styles.TitleBox5} px-0 mx-0`} xs={6}>
        <p className={`${styles.BoldScene} pt-2 pt-md-0` }>{role} </p>
        </Col>
            <Col xs={currentUser?.groups[0]?.name !== "Crew" ? 3 : 2} 
            className={`${styles.TitleBox3} px-0 mx-0`}>
              {costume ? <p className="pt-2 pt-md-0">{costume} </p> : ""}
            </Col>
            {
              currentUser?.groups[0]?.name !== "Crew" &&
              <Col className={`${styles.TitleBox4} text-center px-0 mx-0`} xs={1}>
                <PostDropdown
                  className="pb-2"
                  handleEdit={() => setShowEditForm(true)}
                  handleDelete={handleDelete}
                />
              </Col>
            }
      </Row>
      {/* edit */}
      {showEditForm ? (
        <SceneCharacterEdit
          character={character}
          id={id}
          role={role}
          handleMount={handleMount}
          setCharacters={setCharacters}
          setShowEditForm={setShowEditForm}
        />
      ) : (
        ""
      )}
    </div>
  )
}

export default Character